import api from "./api";

export const home = async () => {
    const { data } = await api.get('products/home/');
    return data
}

export const contentMostAccessed = async () => { 
    const { data } = await api.get('products/objects_more/')

    return data
}
